// extracted by mini-css-extract-plugin
export default {"deals":"deals__39-EL"};
    if(module.hot) {
      // 1791975612223
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  